'use strict';

import moment from 'moment';
import { formatDateAsYearMonthDate } from '../../helpers/DateUtils';

export default class SourceTiff {
  constructor(tiffDate, weight) {
    this.tiffDate = formatDateAsYearMonthDate(tiffDate); // String
    this.weight = weight; // Int, 0-100
  }
}
